export default function getAuth() {
  // const username = 'admin';
  // const password = 'q485400';

  // const username = '79277662056_1';
  // const password = '123456';

  const username = '79193332080_1';
  const password = '123123';

  return `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`;

  // return '';
}
